import Axios from "axios";
import _ from "lodash";
import { CachePocily } from "../common/Cache";
import { ECache } from '../enum/ECache';
import CACHE_KEY from "../constant/cacheKey";
import router from "../router";
import store from "../store";
import RootType from "../store/mutation-types";
import ResponseError from "../model/ResponseError";
var EXPIRE_CODE = 30333;
var UPGRADE_CODE = 30007;
var logout = _.debounce(function () {
    CachePocily.getInstance(ECache.LocCache).remove(CACHE_KEY.LOGIN);
    store.commit(RootType.UPDATE_LOGINMODEL, null);
    router.push({ path: '/' });
}, 500);
var host = "/", emptyResMsg = "返回数据为空，请联系管理员", errorResMsg = "服务器错误，请稍后重试";
_.extend(Axios.defaults, {
    baseURL: host,
    timeout: 300000,
    headers: { 'Content-Type': 'application/json' },
    responseType: 'json',
    validateStatus: function (status) {
        return status >= 200 && status < 300;
    },
    transformRequest: [function (data, headers) {
            if (headers && headers["Content-Type"] === "multipart/form-data") {
                return data;
            }
            if (headers && headers["Content-Type"] === "application/json") {
                return JSON.stringify(data);
            }
            var cacheSqe = [];
            var keySqe = [];
            var param = function (obj) {
                var query = '';
                var name, value, fullSubName, subName, subValue, innerObj, i;
                var index = -1;
                for (name in obj) {
                    value = obj[name];
                    if (cacheSqe.indexOf(value) > -1 && typeof value === 'object') {
                        keySqe.push(name);
                        continue;
                    }
                    if (value instanceof Array) {
                        keySqe.push(name);
                        cacheSqe.push(value);
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name + '[' + i + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                        index = cacheSqe.indexOf(value);
                        cacheSqe.splice(index, 1);
                        keySqe.splice(index, 1);
                    }
                    else if (value instanceof Object) {
                        keySqe.push(name);
                        cacheSqe.push(value);
                        for (subName in value) {
                            subValue = value[subName];
                            fullSubName = name + '[' + subName + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                        index = cacheSqe.indexOf(value);
                        cacheSqe.splice(index, 1);
                        keySqe.splice(index, 1);
                    }
                    else if (value !== undefined && value !== null) {
                        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                    }
                }
                return query.length ? query.substr(0, query.length - 1) : query;
            };
            return (typeof data === 'object') && String(data) !== '[object File]' ? param(data) : data;
        }],
    transformResponse: [function (respData) {
            if (typeof respData === 'string') {
                respData = JSON.parse(respData);
            }
            if (!respData) {
                throw new Error(emptyResMsg);
            }
            if (respData.code === EXPIRE_CODE) {
                logout();
            }
            if (!respData.success || respData.code === UPGRADE_CODE) {
                throw new ResponseError(respData, respData.msg || errorResMsg);
            }
            return respData;
        }],
});
